/**
 * LegalFooter — site-wide footer with UK Companies Act disclosure
 * and direct links to Terms · Privacy · Refund · Support contacts.
 *
 * RC 1.35.F2 Stage-1 P0-4. Mounted in:
 *   - AppLayout (every authenticated route)
 *   - LoginPage / SignupPage (public auth shells)
 *
 * The standalone legal pages (`/terms`, `/privacy`, `/refund`)
 * carry their own contact + copyright in `LegalPageShell` so this
 * footer is intentionally not also mounted there.
 */
import { Link } from 'react-router-dom';

const COMPANY_LINE =
  'The NDORFlow software platform is owned, developed and licensed by ' +
  'NDOR Labs Limited. IAA Energy Resources Limited (Company No. 11583381) ' +
  'is the Authorised Commercial Operator for NDORFlow and is responsible ' +
  'for marketing, sales, subscriptions, billing, payment collection, ' +
  'commercial onboarding and customer support. Registered office: ' +
  '71-75 Shelton Street, Covent Garden, London, England, WC2H 9JQ. ' +
  'Invoices and payment statements will show "IAA Energy Resources Limited".';

export default function LegalFooter({ variant = 'app' }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className={
        variant === 'auth'
          ? 'border-t border-ndor-edge bg-ndor-canvas px-4 sm:px-6 py-5'
          : 'border-t border-ndor-edge bg-ndor-surface px-4 sm:px-6 lg:px-8 py-5 mt-auto'
      }
      data-testid="legal-footer"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-ndor-ink-muted">
          <Link to="/terms"   data-testid="legal-footer-terms"   className="hover:text-ndor-ink hover:underline">Terms</Link>
          <span aria-hidden>·</span>
          <Link to="/privacy" data-testid="legal-footer-privacy" className="hover:text-ndor-ink hover:underline">Privacy</Link>
          <span aria-hidden>·</span>
          <Link to="/refund"  data-testid="legal-footer-refund"  className="hover:text-ndor-ink hover:underline">Refund Policy</Link>
          <span aria-hidden>·</span>
          <a
            href="mailto:support@ndor.app?subject=NDORFlow%20-%20Support%20request"
            data-testid="legal-footer-support"
            className="hover:text-ndor-ink hover:underline"
          >
            Support
          </a>
          <span aria-hidden>·</span>
          <a
            href="mailto:support@ndor.app?subject=NDORFlow%20-%20Billing"
            data-testid="legal-footer-billing"
            className="hover:text-ndor-ink hover:underline"
          >
            Billing
          </a>
        </nav>
        <p className="text-[11px] text-ndor-ink-muted" data-testid="legal-footer-copyright">
          © {year} NDOR Labs Limited. All rights reserved.
        </p>
      </div>
      <p
        className="mt-3 max-w-5xl mx-auto text-[11px] text-ndor-ink-muted leading-relaxed"
        data-testid="legal-footer-company-line"
      >
        {COMPANY_LINE}
      </p>
    </footer>
  );
}
